import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Internship } from "./types";

interface Props {
  internship: Internship;
}

const InternshipCapacity: React.FC<Props> = ({ internship }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {t("shadowing.occupied_slots")}: {internship.occupiedApplications} {t("common.from")}{" "}
      {internship.participantsCapacity}
    </Fragment>
  );
};

export default InternshipCapacity;
